import { render } from "./SearchResultPage.vue?vue&type=template&id=7ba412e8&scoped=true&ts=true"
import script from "./SearchResultPage.vue?vue&type=script&lang=ts"
export * from "./SearchResultPage.vue?vue&type=script&lang=ts"

import "./SearchResultPage.vue?vue&type=style&index=0&id=7ba412e8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba412e8"]])

export default __exports__